__turbopack_context__.v({
  "button": "doTdVq_button",
  "buttons": "doTdVq_buttons",
  "container": "doTdVq_container",
  "heading": "doTdVq_heading",
  "headingContainer": "doTdVq_headingContainer",
  "quickTipWrapper": "doTdVq_quickTipWrapper",
  "quickTips": "doTdVq_quickTips",
});
